/**
 * Navigation reducer
 * @namespace navigation_reducer
 * @category Redux
 * @subcategory Reducers
 */
// eslint-disable-next-line
const navigation_reducer = {};
//used for the namespace in the documentation

/**
 * The initial navigation state
 * @memberof navigation_reducer
 */
const initState = {
  //public transit layer
  bus: {
    iconURL: "/icons/bus.webp",
    isActive: false,
    mapElement: "Markers",
  },
  tram: {
    iconURL: "/icons/tram.webp",
    isActive: true,
    mapElement: "Markers",
  },
  trolley: {
    iconURL: "/icons/trolley.webp",
    isActive: true,
    mapElement: "Markers",
  },
  subwayStations: {
    iconURL: "/icons/subway.webp",
    isActive: true,
    mapElement: "Markers",
  },
  subwayLines: {
    iconURL: "/icons/subway.webp",
    isActive: true,
    mapElement: "Polylines",
  },
  //

  //alternative transit layer
  hobo: {
    iconURL: "/icons/hobo.webp",
    isActive: false,
    mapElement: "Markers",
  },
  spark: {
    iconURL: "/icons/spark.webp",
    isActive: false,
    mapElement: "Markers",
  },
  //

  //ev infrastructure layer
  charger: {
    iconURL: "/icons/charger.webp",
    isActive: false,
    mapElement: "Markers",
  },
  //

  //green infrastructure layer
  cycleways: {
    iconURL: "/icons/cycleways.webp",
    isActive: false,
    mapElement: "Polylines",
  },
  greenCorridor1: {
    iconURL: "/icons/polygon.webp",
    isActive: false,
    mapElement: "Polygons",
  },
  greenCorridor2: {
    iconURL: "/icons/polygon.webp",
    isActive: false,
    mapElement: "Polygons",
  },
  greenCorridor3: {
    iconURL: "/icons/polygon.webp",
    isActive: false,
    mapElement: "Polygons",
  },
  //kanachkova
  reconstructionsTemporary: {
    iconURL: "/icons/polygon.webp",
    isActive: false,
    mapElement: "Reconstruction",
  },
  reconstructionsPermanent: {
    iconURL: "/icons/polygon.webp",
    isActive: false,
    mapElement: "Reconstruction",
  },
};

/**
 * Redux navigation reducer
 * @category Redux
 * @subcategory Reducers
 * @memberof navigation_reducer
 * @function navigationReducer
 * @param {object} state the state of the reducer
 * @param {object} action the actions for the reducer
 */
const navigationReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_NAV_TRAM":
      return {
        ...state,
        tram: {
          iconURL: "/icons/tram.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_TROLLEY":
      return {
        ...state,
        trolley: {
          iconURL: "/icons/trolley.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_BUS":
      return {
        ...state,
        bus: {
          iconURL: "/icons/bus.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_SUBWAY_STATIONS":
      return {
        ...state,
        subwayStations: {
          iconURL: "/icons/subway.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_SUBWAY_LINES":
      return {
        ...state,
        subwayLines: {
          iconURL: "/icons/subway.webp",
          isActive: action.payload,
          mapElement: "Polylines",
        },
      };
    case "SET_NAV_HOBO":
      return {
        ...state,
        hobo: {
          iconURL: "/icons/hobo.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_SPARK":
      return {
        ...state,
        spark: {
          iconURL: "/icons/spark.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_CHARGER":
      return {
        ...state,
        charger: {
          iconURL: "/icons/charger.webp",
          isActive: action.payload,
          mapElement: "Markers",
        },
      };
    case "SET_NAV_GREEN_CORRIDOR_ONE":
      return {
        ...state,
        greenCorridor1: {
          iconURL: "/icons/polygon.webp",
          isActive: action.payload,
          mapElement: "Polygons",
        },
      };
    case "SET_NAV_GREEN_CORRIDOR_TWO":
      return {
        ...state,
        greenCorridor2: {
          iconURL: "/icons/polygon.webp",
          isActive: action.payload,
          mapElement: "Polygons",
        },
      };
    case "SET_NAV_GREEN_CORRIDOR_THREE":
      return {
        ...state,
        greenCorridor3: {
          iconURL: "/icons/polygon.webp",
          isActive: action.payload,
          mapElement: "Polygons",
        },
      };
    case "SET_NAV_CYCLEWAYS":
      return {
        ...state,
        cycleways: {
          iconURL: "/icons/cycleways.webp",
          isActive: action.payload,
          mapElement: "Polylines",
        },
      };
    case "SET_NAV_RECONSTRUCTIONS_TEMPORARY":
      return {
        ...state,
        reconstructionsTemporary: {
          iconURL: "/icons/temporaryOrganization.webp",
          isActive: action.payload,
          mapElement: "Reconstructions",
        },
      };
    case "SET_NAV_RECONSTRUCTIONS_PERMANENT":
      return {
        ...state,
        reconstructionsPermanent: {
          iconURL: "/icons/temporaryOrganization.webp",
          isActive: action.payload,
          mapElement: "Reconstructions",
        },
      };
    default:
      return state;
  }
};

export default navigationReducer;
